import React, { Component } from 'react';
import {
	Panel,
	ListGroup,
	ListGroupItem
} from 'react-bootstrap';

import security from '../../../components/common/security/security';
import { USER_ROLES } from '../../../config/constants';

import './InputsStyle.css';

class CollapseList extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isOpen: this.props.expanded,
			shopName: '',
		};
		this.renderList = this.renderList.bind(this);
		this.setArrows = this.setArrows.bind(this);
	}

	renderList(item, id) {
		if (typeof item === 'object'){
			const location = item.location ? item.location.address : '';
			const shopName = location ? (item.shopName - location) : item.shopName;
			return(
				<ListGroupItem key={id}>{shopName}</ListGroupItem>
			);
		}
		return(
			<ListGroupItem key={id}>
				{item}
			</ListGroupItem>
		);
	}

	isCollapsed() {
		this.setState({
			isOpen: !this.state.isOpen
		});
	}

	renderListGroup() {
		const {isList, list, child} = this.props;
		let className = this.state.isOpen ? 'show' : 'hidden';
		let	additionalStyle = security.getUser().role === USER_ROLES.ORDER_MANAGER ? ' padding-vertical' : '';
		if (isList) {
			return(
				<ListGroup fill className={`${className} ${additionalStyle}`}>
					{list.map(this.renderList)}
				</ListGroup>
			);
        }

        className += child ? ' child-container' : '';
        className += this.props.childClassName ? ` ${this.props.childClassName}` : '';
		return(
			<div fill='true' className={'comments scrollable ' + className}>
				<span>{list}</span>
				{child}
			</div>
		);
	}

	setArrows() {
		let className = 'glyphicon-chevron-down';
		if (this.state.isOpen) {
			className = 'glyphicon-chevron-up';
		}
		return className;
	}

	render() {
		return (
			<Panel
				defaultExpanded={this.props.expanded}
				className="pointer">
				<Panel.Heading>
					<div onClick={() => this.isCollapsed()}>
						<span>{this.props.headerTitle}</span>
						<span className={"glyphicon pull-right " + this.setArrows()}>
						</span>
					</div>
				</Panel.Heading>
				<Panel.Body>{this.renderListGroup()}</Panel.Body>
			</Panel>
		);
	}
}

export default CollapseList;